var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.486,
    height: 123.099,
    viewBox: "0 0 111.486 123.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.353,90.316A16.925,16.925,0,0,0,85.24,94.955L40.833,69.284a20.8,20.8,0,0,0,.622-4.331,20.789,20.789,0,0,0-.622-4.331l43.789-25.36a18.7,18.7,0,0,0,31.364-13.61,18.633,18.633,0,0,0-37.266,0,20.675,20.675,0,0,0,.622,4.331L35.555,51.343A18.693,18.693,0,0,0,22.822,46.4,18.386,18.386,0,0,0,4.5,64.953a18.7,18.7,0,0,0,31.365,13.61l44.1,25.671a15.516,15.516,0,0,0-.622,4.02A18.011,18.011,0,1,0,97.353,90.316Z",
    transform: "translate(-4.5 -3.094)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.3d847b3257579fdf1c83d9bff56c1fa3.svg";
export { ForwardRef as ReactComponent };